module.exports = __webpack_public_path__ + "img/FormTemplates.3b9835fd.svg";